import React from 'react'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { scoredOptions } from '@/utils/constants'
import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'

export const PartialScoresFilter = ({ filters, ...props }) => {
  const label = 'QA Score Status'
  const accessor = 'scoredStatus'
  const placeholder = 'Scored'

  return (
    <FormField data-testid={`${accessor}-dropdown`}>
      <label>{label}</label>
      <InteractiveTooltip
        content="Please select at least one scorecard"
        hide={!props.isDisabled}
        block
      >
        <Select
          placeholder={placeholder}
          options={scoredOptions}
          fixedWidth
          value={filters[accessor]}
          {...props}
        />
      </InteractiveTooltip>
    </FormField>
  )
}
